import { Theme, css, useTheme } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Typography } from 'chatie-design-system';

import Pad from '@components/layout/Pad';

import { IStoryPublishSummary } from '@model';
import { formatDate, getOnlyDate, isAfter } from '@utils/date';

const titleCSS = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  ${Typography.h6};
  line-height: 100%;
  text-align: center;

  .highlight {
    background-image: linear-gradient(160deg, #17dce4 0%, #4db4ee 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .title {
    .crown {
      text-align: center;
      height: 17px;
    }
  }

  .time {
    font-size: 8px;
    font-weight: 400;
    color: ${theme.var.gray400};
  }
`;

const SimpleStampRanking = ({
  weeklySummary,
}: {
  weeklySummary: IStoryPublishSummary;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const today = new Date();

  const isPublishInCurrentWeek =
    weeklySummary &&
    isAfter(today, new Date(weeklySummary.startDateKst)) &&
    !isAfter(
      getOnlyDate(today),
      getOnlyDate(new Date(weeklySummary.endDateKst))
    );

  const isInRanking =
    isPublishInCurrentWeek &&
    weeklySummary.stampRanking &&
    weeklySummary.stampRanking.rank < 1000;

  if (!isPublishInCurrentWeek) {
    return null;
  }

  return (
    <Pad backgroundColor={theme.border.space}>
      <div css={titleCSS}>
        {weeklySummary?.stampRanking && (
          <>
            <p className="title">
              {t('1일 1연재 스탬프')}

              <span className="highlight">
                {t(
                  isInRanking
                    ? ` 랭킹 ${weeklySummary.stampRanking?.rank}등`
                    : ' 순위권 진입 준비중'
                )}
              </span>
              <span className="crown">
                {t(!isInRanking ? '이에요!' : ' 👑')}
              </span>
            </p>
            <span className="time">
              {t(
                ` ${formatDate(
                  new Date(weeklySummary.stampRanking.lastUpdatedAt),
                  'yyyy.MM.dd HH:mm'
                )} 기준`
              )}
            </span>
          </>
        )}
      </div>
    </Pad>
  );
};
export default SimpleStampRanking;
